export function detectYoutube(content) {
    var _a;
    return ((_a = content.meta) === null || _a === void 0 ? void 0 : _a.type) === 'video:youtube';
}
export function getEmbedUrlForId(id, options) {
    if (!id)
        return '';
    var url = new URL("https://www.youtube.com/embed/".concat(id));
    if (options === null || options === void 0 ? void 0 : options.rel) {
        url.searchParams.set('rel', options.rel);
    }
    if (typeof (options === null || options === void 0 ? void 0 : options.origin) !== 'undefined') {
        url.searchParams.set('origin', options === null || options === void 0 ? void 0 : options.origin);
    }
    return url.href;
}
//# sourceMappingURL=youtube.js.map